module.exports = __webpack_public_path__ + "static/media/psophus_stridulus_001_APA.15824ca7.mp3";